<template>
    <div class="banbar" :class="{ active: isActive }" :key="isActive">
        <div class="lf">
            <img src="@/assets/images/logo.png" alt="">
        </div>
        <div class="rg">
            <div class="btn" @click="router.push('/BullMarketBrokers')">Abrir Cuenta</div>
        </div>
    </div>
    <div class="zhanwei"></div>
</template>


<script lang="ts" setup name="navbarPage">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const isActive = ref(false)

// 滚动处理函数
const handleScroll = () => {
    const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

    isActive.value = scrollTop > 50 // 滚动 10px 就触发
}

onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped lang="scss">
.zhanwei {
    height: 64px;
}

.banbar {
    width: 100%;
    max-width: 600px;
    height: 64px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99;

    .lf {
        display: flex;
        align-items: center;

        img {
            width: 133px;
        }
    }

    .rg {
        display: flex;
        align-items: center;

        .btn {
            padding: 10px 15px;
            color: #fff;
            font-size: 12px;
            background: #1e27f3;
            border-radius: 500px;
            font-weight: 700;
        }
    }

    &.active {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
        background-color: #fff !important;
    }
}

@media screen and (min-width: 601px) {
    .zhanwei {
        height: 80px;
    }
    .banbar {
        width: 100%;
        max-width: 100%;
        height: 80px;
        padding: 0 calc((100vw - 1290px) / 2);

        .lf {
            padding-left: 15px;

            img {
                width: 177px;
            }
        }

        .rg {
            padding-right: 15px;

            .btn {
                padding: 14px 20px;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
                transition: all 0.3s;
                &:hover{
                    background-color: #0e0e0e;
                }
            }
        }
    }
}
</style>